module.exports = __webpack_public_path__ + "static/media/wine-shop-banner.742f14f0.jpg";